
import React from 'react';
import { useNavigate } from 'react-router-dom';

const ChapterNotFound: React.FC = () => {
  const navigate = useNavigate();
  
  const handleGoHome = () => {
    navigate('/home', { replace: true });
  };
  
  const handleGoBack = () => {
    if (window.history.length > 2) {
      navigate(-1);
    } else {
      navigate('/home', { replace: true });
    }
  };
  
  return (
    <div className="pulse-container min-h-[var(--app-height)] overflow-y-auto p-4 flex items-center justify-center min-h-screen">
      <div className="rounded-lg bg-gray-50 text-gray-600 p-6 max-w-md w-full shadow-md">
        <h2 className="font-bold text-xl mb-3">Capítulo Não Encontrado</h2>
        <p className="mb-4">O capítulo que você está procurando não pôde ser encontrado ou não está disponível.</p>
        <div className="space-y-3">
          <button 
            onClick={handleGoBack} 
            className="w-full px-4 py-2 bg-gray-200 hover:bg-gray-300 text-gray-700 rounded-lg transition-colors"
          >
            Voltar
          </button>
          <button 
            onClick={handleGoHome} 
            className="w-full px-4 py-2 bg-primary-900 text-white rounded-lg hover:bg-primary-800 transition-colors"
          >
            Voltar para Página Inicial
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChapterNotFound;
